/* Customer hub drawer — native <dialog> (focus trap, Esc, backdrop
   come free). Reads NO customer data: personalization is server-side
   Liquid. Recently-viewed keeps the legacy localStorage key
   (shopHub_recent_v3) and object shape so existing history survives. */

(function () {

  var KEY_RECENT = 'shopHub_recent_v3';
  var DISPLAY_CAP = 4;

  function getList() {
    try { return JSON.parse(localStorage.getItem(KEY_RECENT) || '[]'); }
    catch (e) { return []; }
  }

  function saveList(list) {
    try { localStorage.setItem(KEY_RECENT, JSON.stringify(list.slice(0, 12))); }
    catch (e) { /* storage unavailable — feature simply idles */ }
  }

  function upsert(list, item) {
    var i = list.findIndex(function (p) {
      return String(p.id) === String(item.id) || p.url === item.url;
    });
    if (i > -1) list.splice(i, 1);
    list.unshift(item);
    return list;
  }

  document.addEventListener('DOMContentLoaded', function () {

    var root = document.querySelector('[data-hub-root]');
    if (!root) return;

    var dialog = root.querySelector('[data-hub-dialog]');
    var fab = root.querySelector('[data-hub-open]');

    /* --- Drawer controls --- */

    if (dialog && fab) {
      fab.addEventListener('click', function () {
        if (typeof dialog.showModal === 'function') {
          dialog.showModal();
        } else {
          dialog.setAttribute('open', '');
        }
        document.documentElement.style.overflow = 'hidden';
      });

      root.querySelectorAll('[data-hub-close]').forEach(function (btn) {
        btn.addEventListener('click', function () {
          if (typeof dialog.close === 'function') dialog.close();
          else dialog.removeAttribute('open');
        });
      });

      // Backdrop tap: a click landing on the dialog element itself
      dialog.addEventListener('click', function (e) {
        if (e.target === dialog) dialog.close();
      });

      // Esc closes natively; restore scroll + focus on every close path
      dialog.addEventListener('close', function () {
        document.documentElement.style.overflow = '';
        try { fab.focus(); } catch (e) { /* fab gone — fine */ }
      });
    }

    /* --- Recently viewed: record the current product --- */

    var pid = root.getAttribute('data-hub-product');
    if (pid) {
      var list = upsert(getList(), {
        id: pid,
        title: root.getAttribute('data-hub-product-title') || '',
        url: root.getAttribute('data-hub-product-url') || '',
        image: root.getAttribute('data-hub-product-image') || '',
        price: root.getAttribute('data-hub-product-price') || ''
      });
      saveList(list);
    }

    /* --- Recently viewed: render (cap 4, drop unresolvable) --- */

    var recentWrap = root.querySelector('[data-hub-recent]');
    var recentList = root.querySelector('[data-hub-recent-list]');
    if (recentWrap && recentList) {
      var items = getList().filter(function (p) {
        return p && p.url && p.title;
      }).slice(0, DISPLAY_CAP);

      if (items.length) {
        items.forEach(function (p) {
          var row = document.createElement('div');
          row.className = 'bs-hub__rv-row';

          var thumb = document.createElement('img');
          thumb.className = 'bs-hub__rv-thumb';
          thumb.width = 38;
          thumb.height = 38;
          thumb.alt = '';
          thumb.loading = 'lazy';
          if (p.image) thumb.src = p.image;
          row.appendChild(thumb);

          var info = document.createElement('div');
          info.className = 'bs-hub__rv-info';
          var name = document.createElement('p');
          name.className = 'bs-hub__rv-name';
          name.textContent = p.title;
          info.appendChild(name);
          if (p.price) {
            var price = document.createElement('p');
            price.className = 'bs-hub__rv-price';
            price.textContent = p.price;
            info.appendChild(price);
          }
          row.appendChild(info);

          var view = document.createElement('a');
          view.className = 'bs-hub__rv-view';
          view.href = p.url;
          view.textContent = 'View';
          row.appendChild(view);

          recentList.appendChild(row);

          // Skip products that no longer resolve: validate quietly and
          // remove the row (and stored entry) on 404
          var handlePath = (p.url || '').split('?')[0];
          if (handlePath) {
            fetch(handlePath + '.js').then(function (r) {
              if (r.status === 404) {
                row.remove();
                saveList(getList().filter(function (q) { return q.url !== p.url; }));
                if (!recentList.children.length) recentWrap.hidden = true;
              }
            }).catch(function () { /* offline — leave the row */ });
          }
        });
        recentWrap.hidden = false;
      }
    }

  });

})();
